import { Switch, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoonStars, IconSun } from '@tabler/icons-react';
import { use, useCallback } from 'react';

import { ProjectContext } from '#contexts/ProjectContext';

export function ColorSchemeToggleButton() {
  const { config } = use(ProjectContext);
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme(config?.defaultColorScheme);
  const toggleColorScheme = useCallback(() => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
  }, [setColorScheme, computedColorScheme]);

  return (
    <Switch
      color="dark.8"
      label="Dark mode"
      onLabel={<IconMoonStars size={16} stroke={2.5} color="var(--mantine-color-blue-6)" />}
      offLabel={<IconSun size={16} stroke={2.5} color="var(--mantine-color-yellow-4)" />}
      checked={computedColorScheme === 'dark'}
      onClick={toggleColorScheme}
    />
  );
}
